import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Equipment from '../components/Equipment';
import WhyChoose from '../components/WhyChoose';
import Testimonial from '../components/Testimonial';
import Footer from '../components/Footer';

const HomePage = () => {
    return (
        <div className="home-page">
            <Navbar />
            <Hero />
            <About />
            <Equipment />
            <WhyChoose />
            <Testimonial />
            <Footer />
        </div>
    );
};

export default HomePage;
